// This is shonkyriffic but should do the job.
import config from "../boot/config";
import http from "../boot/http.js";

let _allTagsCache = [];
const baseRoute = config.ibmsBaseUrl.replace('\r', '');

export default class {

  /**
   * @returns {Promise<[]>} A promise which will resolve to all available tags.
   */
  static async getTags(filterTags) {

    if (_allTagsCache.length > 0 && (filterTags == null || filterTags.length === 0))
      return Promise.resolve(_allTagsCache);

    let saveToCache = true;

    let url = `${baseRoute}/TrendableObject/GetTags`;

    if (filterTags != null && filterTags.filter(x => x.tag != null && x.value != null).length > 0) {
      let filterStr = filterTags.map(x => {
        return `${x.tag}=${x.value}`;
      }).join(',');

      url = `${url}?filterTags=${filterStr}`;
      saveToCache = false;
    }

    return http({
      url,
      method: "GET"
    }).then((d) => {

      if (saveToCache)
        _allTagsCache = d;

      return d;
    });
  }

  /**
   * @param {string} groupTag Somewhat of a misnomer, this is more like the "primary tag".
   * @param {TagValue[]} filterTags An array of tags and their values you wish to
   *                     use to filter the returned results against.
   *
   * @returns {Promise<[]>} All tag values for the original tag minus those not passing the
   *               filter/s.
   */
  static async getTagValues(groupTag, filterTags) {

    if (groupTag == null || groupTag === "")
      return Promise.resolve([]);

    let url = `${baseRoute}/TrendableObject/GetTagValues`;

    return http({
      url,
      method: "GET",
      params: {
        tag: groupTag,
        filterTags
      }
    });
  }

  /**
   * Returns ALL trendable objects for EVERY available group tag VALUE (as returned from the api) and then filtered.
   * by the filter tags.
   *
   * Note that 'duplicates' (??) are returned in the data. These are merged/squashed later.
   * See mergePointsFromAdvancedSearch below.
   *
   * @param {string} groupTag Somewhat of a misnomer, this is more like the "primary tag".
   * @param {TagValue[]} filterTags
   * @param {Boolean} useAnd Specify 'true' if join logic should be 'true'.
   * @returns {Promise<[]>}
   */
  static async advancedSearch(
    groupTag,
    filterTags,
    useAnd = true) {

    if (groupTag == null || groupTag === "")
      throw "Invalid groupTag specified";

    if (filterTags == null || filterTags.length === 0)
      throw "Must supply at least 1 filter"; // TODO: Maybe not?

    const allTagsAreValid = filterTags.every(x => (x.tag != null && x.tag !== "") && (x.value != null && x.value !== ""));
    if (!allTagsAreValid)
      throw "1 or more tags is missing either a tag name or value. All data must be present for searching";


    const url = `${baseRoute}/TrendableObject/Search`;

    // For the primary ('group') tag, retrieve ALL possible values.
    let allGroupTagValues = await this.getTagValues(groupTag);

    let promises = [];
    let groupData = [];

    const types = `"Sample"`;

    // A json encoded list of search terms + misc. Refer to swagger doc (...)
    const searchTerms = `[{
      "searchBy":"TagValues",
      "tagValues":{${filterTags.map(x => `"${x.tag}":"${x.value}"`).join(',')}}
    }, {
      "searchBy":"Types",
      "types":[${types}]
    }]`;

    promises.push(http({
      url,
      method: "GET",
      params: {
        searchTerms,
        useAnd: useAnd ? "true" : "false"
      }
    }).then(data => {

      allGroupTagValues.forEach(grpTagVal => {
        if (grpTagVal != "") {
          const returnedPointsForGrpVal = data.filter(x => x.tagValues[groupTag] === grpTagVal);
          groupData.push({ tag: groupTag, value: grpTagVal, points: returnedPointsForGrpVal });
        }
      });
    })
      .catch(error => console.log("Couldn't find data for that combination.")));

    return Promise.all(promises).then(data => groupData);

  }

  /** Merges point data by looking at which objects have certain bits of identical data */
  static mergePointsFromAdvancedSearch(searchResults) {

    // incoming will be in the format: [[], [], []] with each subarray representing the search results from a group tag
    // value.
    // Output will be the same format, with 'duplicates' removed.

    const outputArray = [];

    searchResults.forEach(group => {

      const nonDupes = [];
      const insertedIds = {};
      // let units = null;

      group.points.forEach(trendableObj => {

        const identifier = trendableObj.databaseID;

        if (insertedIds[identifier] == null) {
          insertedIds[identifier] = true;

          nonDupes.push(trendableObj);
        }

      });

      // Only include groups that have points.
      if (nonDupes.length > 0) {
        outputArray.push({ tag: group.tag, value: group.value, points: nonDupes });
      }

    });

    return outputArray;
  }

}

/** Links a Tag to an allowable Value. Used for filtering. */
export class TagValue {
  tag;
  value;
}


// WEBPACK FOOTER //
// ./src/services/tags.js